import { IInitialState, IArrivalDetail } from "./interfaces";

export const initialArrivalData: IArrivalDetail = {
  id: null,
  cart_id: null,
  cart_item_id: null,
  calendar_id: null,
  product_id: null,
  total: null,
  tax: null,
  state_name: "",
  data: {
    additional_options: [],
    comments: {
      guest: "",
      partner: "",
    },
    inventory: {
      description: "",
      duration: "",
      id: "",
      name: "",
    },
    product: {
      booking_fee: "",
      id: "",
      name: "",
      need_tickets_guests: "",
      product_type: "",
      tax: "",
    },
    schedule: { id: 0, time: "" },
    tickets: [],
  },
  made: "",
  date: "",
  first_name: "",
  last_name: "",
  phone: "",
};

export const initialState: IInitialState = {
  arrivalData: initialArrivalData || 0,
  receivedData: 0,
  showError: false,
  loading: true,
};
